<!-- <mat-sidenav-container>
  <mat-sidenav #sidenav mode="side" opened> -->
<div id="sidebar" class="sidebar sidebar-grid" [ngClass]="{ 'sidebar-transparent': this.pageSidebarTransparent}"
    data-disable-slide-animation="true">
    <!-- begin sidebar scrollbar -->
    <perfect-scrollbar class="height-full" #sidebarScrollbar (scroll)="onScroll($event)">
        <ng-container *ngTemplateOutlet="sidebarNav"></ng-container>
    </perfect-scrollbar>
    <!-- end sidebar scrollbar -->

    <ng-template #sidebarNav>
        <!-- begin sidebar user -->
        <ul class="nav">
            <li class="nav-profile" [ngClass]="{ 'active' : (navProfileState == 'expand') }">
                <div class="cover with-shadow"></div>
                <div class="image">
                    <img *ngIf="logo==null"
                        src="https://firebasestorage.googleapis.com/v0/b/thaidevgroup-89222.appspot.com/o/img_not_available.jpeg?alt=media&token=0925dce1-6ab6-4bc0-a397-cd881ba2bcfd" />
                    <img *ngIf="logo!=null" (error)="errorHandler($event)" [src]="logo" />
                </div>
                <div class="info">
                    ร้าน : {{name_company}}
                    <small>
                        สาขา : {{branch_name}}
                    </small>
                    <br>
                    <small>Jpos 2021 Version Online</small>
                </div>
                <div class="info" style="margin-top: 10px;">
                    <label>วันใช้งานคงเหลือ {{num_expire}} วัน</label>
                </div>
            </li>
            <!-- <ul class="nav nav-profile" [style.display]="(navProfileState == 'expand') ? 'block' : ''">
                <li><a href="javascript:;"><i class="fa fa-cog"></i> Settings</a></li>
                <li><a href="javascript:;"><i class="fa fa-pencil-alt"></i> Send Feedback</a></li>
                <li><a href="javascript:;"><i class="fa fa-question-circle"></i> Helps</a></li>
            </ul> -->
        </ul>
        <!-- end sidebar user -->
        <!-- begin sidebar nav -->
        <ul class="nav">
            <li class="nav-search" *ngIf="pageSettings.pageSidebarSearch">
                <input type="text" class="form-control" placeholder="Sidebar menu filter..."
                    (keyup)="sidebarSearch($event)" />
            </li>
            <li class="nav-header">Navigation</li>

            <!-- render sidebarMenuNav -->
            <ng-template #sidebarMenuNav let-menu="menu">
                <span class="badge pull-right" *ngIf="menu.badge">{{ menu.badge }}</span>
                <b class="caret" *ngIf="menu.caret"></b>
                <!-- <i class="fas fa-caret-down"></i> -->
                <div class="icon-img" *ngIf="menu.img"><img src="{{ menu.img }}" /></div>
                <i class="material-icons" *ngIf="menu.icon">{{menu.icon}}</i>
                <span *ngIf="menu.title">
                    {{ menu.title | translate}}
                    <span class="label label-theme" *ngIf="menu.label">{{ menu.label }}</span>
                </span>
            </ng-template>

            <!-- render sidebarSubMenuNav -->
            <ng-template #sidebarSubMenuNav let-menu="menu">
                <!-- <b class="caret" *ngIf="menu.caret"></b> -->
                <i class="{{menu.subicon}}" style="padding-left: 0; margin-left: 0;" *ngIf="menu.subicon"></i>
                <span *ngIf="menu.title" style="font-size: 14px; padding-left: 0; margin-left: 0;">
                    {{ menu.title | translate}}
                </span>
            </ng-template>

            <!-- sidebar menu -->
            <li *ngFor="let menu of menus" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                [ngClass]="{ 'expand': menu['submenu'], 'has-sub': menu['submenu'], 'd-none': menu['hide'] }"
                #rla="routerLinkActive">
                <a href="javascript:;" *ngIf="menu['submenu']" (click)="expandCollapseSubmenu(menu, menus, rla)"
                    (mouseenter)="showPageFloatSubMenu(menu['submenu'], $event)" (mouseleave)="hidePageFloatSubMenu()">
                    <ng-container *ngTemplateOutlet="sidebarMenuNav; context: {menu: menu | translate}"></ng-container>
                </a>
                <a href="javascript:;" *ngIf="!menu['submenu']" [routerLink]="menu.url">
                    <ng-container *ngTemplateOutlet="sidebarMenuNav; context: {menu: menu | translate}"></ng-container>
                </a>

                <!-- submenu lvl 1 -->
                <ul class="sub-menu" *ngIf="menu['submenu']"
                    [style.display]="(menu['state'] == 'expand' && !pageSettings.pageSidebarMinified) ? 'block' : (menu['state'] == 'collapse') ? 'none' : ''">
                    <li *ngFor="let menu1 of menu['submenu']" routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: true}"
                        [ngClass]="{ 'expand': menu1['state'] == 'expand', 'closed': menu1['state'] == 'collapsed', 'has-sub': menu1['submenu'], 'd-none': menu1['hide'] }"
                        #rla1="routerLinkActive">

                        <a *ngIf="menu1['submenu']"
                            (click)="(menu1['submenu']) ? expandCollapseSubmenu(menu1, menu['submenu'], rla1) : ''">
                            <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu1}"></ng-template>
                        </a>
                        <a *ngIf="!menu1['submenu']" [routerLink]="menu1.url"
                            style="margin-left: 0; padding-left: 20px; padding-right: 1px;">
                            <ng-template *ngTemplateOutlet="sidebarSubMenuNav; context: {menu: menu1}"></ng-template>
                        </a>
                    </li>
                </ul>
            </li>
            <li><a href="javascript:;" class="sidebar-minify-btn" (click)="toggleMinified()"><i
                        class="fa fa-angle-double-left"></i></a></li>
        </ul>
    </ng-template>
</div>
<!-- </mat-sidenav> -->
<!-- <mat-drawer-content>Main content</mat-drawer-content> -->

<div class="sidebar-bg"></div>
<!-- end #sidebar -->

<float-sub-menu *ngIf="pageSettings.pageSidebarMinified" [menus]="pageFloatSubMenu" [top]="pageFloatSubMenuTop"
    [left]="pageFloatSubMenuLeft" [right]="pageFloatSubMenuRight" [bottom]="pageFloatSubMenuBottom"
    [arrowTop]="pageFloatSubMenuArrowTop" [arrowBottom]="pageFloatSubMenuArrowBottom"
    [lineTop]="pageFloatSubMenuLineTop" [lineBottom]="pageFloatSubMenuLineBottom"
    (remainPageFloatSubMenu)="remainPageFloatSubMenu()" (hidePageFloatSubMenu)="hidePageFloatSubMenu()"
    (calculateFloatSubMenuPosition)="calculateFloatSubMenuPosition()">
</float-sub-menu>
<!-- </mat-sidenav-container> -->